var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('AcceptInvite',{attrs:{"invite_token":_vm.invite_token,"tos_text":_vm.tos_text,"require_tos_scroll":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }